<template>
    <div class="cstm_vuexy_table table-responsive">
        <!-- <table class="w-full">
            <thead>
                <tr>
                    <th>Payment Date</th>
                    <th>Payment Period</th>
                    <th>Payment Method</th>
                    <th>Hourly Rate</th>
                    <th>Minimum Daily Guaranteed</th>
                    <th>Total hours worked</th>
                    <th>Total guaranteed hours</th>
                    <th>Total Payment </th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(eachData, index) in payslips" :key="index">
                    <td>
                        {{ eachData.date }}
                    </td>
                    <td>
                        {{ eachData.period }}
                    </td>
                    <td>
                        {{ eachData.method }}
                    </td>
                    <td>
                        {{ eachData.rate }}
                    </td>
                    <td>
                        {{ eachData.minimum_daily_guaranteed }}
                    </td>
                    <td>
                        {{ eachData.total_hours_worked }}
                    </td>
                    <td>
                        {{ eachData.total_guaranteed_hours }}
                    </td>
                    <td>
                        {{ eachData.total_payment }}
                    </td>
                    <td>
                        <a style="cursor: pointer;" class="primary">View Payslip</a>
                    </td>
                </tr>
            </tbody>
        </table> -->
        <table class="w-full">
            <thead>
                <tr>
                    <th>From Date</th>
                    <th>To Date</th>
                    <th>Per Hour Payment</th>
                    <th>Total Hour</th>
                    <th>Total Payment</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(eachData, index) in payslips" :key="index">
                    <td>
                        {{ eachData.from_date }}
                    </td>
                    <td>
                        {{ eachData.to_date }}
                    </td>
                    <td>
                        {{ eachData.per_hour_payment }}
                    </td>
                    <td>
                        {{ eachData.total_hour }}
                    </td>
                    <td>
                        {{ eachData.total_payment }}
                    </td>
                    <td>
                        <a style="cursor: pointer;" class="primary" @click="paySlipSidebarFunction(eachData.id)">View Payslip</a>
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="full-cstm-sidebar" :class="{ open: paySlipSidebar }">
          <div class="mt-6 flex items-center justify-between px-6">
            <div>
              <h4 class="inline-flex whitespace-nowrap">Payslip</h4>
            </div>
            <feather-icon
              icon="XIcon"
              class="cursor-pointer"
              @click="paySlipSidebar = false"
            />
          </div>
          <vs-divider class="mb-0" />

          <StaffpayoutDetails
            v-if="paySlipSidebar && payid"
            :pdf="false"
            :payid="payid"
          ></StaffpayoutDetails>
        </div>
        <div style="z-index: 100000;" class="bg-overlay"></div>
    </div>
</template>

<script>
import { fetchStaffFinanceBySearch } from '@/api/finance'
import StaffpayoutDetails from '@/views/pages/finance/components/StaffpayoutDetails.vue'

export default {
  components:{
    StaffpayoutDetails
  },
  data () {
    return {
      query_page: {
        current_page: 1,
        has_next: true,
        limit: 20,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      //   payslips: [
      //     {
      //       id: 1,
      //       date: 'Thursday 8th March, 2022',
      //       period: '1/3/2022 - 7/3/2022',
      //       method: 'Cash',
      //       rate: '£20',
      //       minimum_daily_guaranteed: '2',
      //       total_hours_worked: '4.5',
      //       total_guaranteed_hours: '4.5',
      //       total_payment: '£90.00'
      //     }
      //   ],
      payslips:[],
      payid:null,
      paySlipSidebar:false
    }
  },
  mounted () {
    this.fetchInvoiceListBySearch() 
  },
  methods: {
    paySlipSidebarFunction (id) {
      this.payid = id
      this.paySlipSidebar = true
    },
    async fetchInvoiceListBySearch () {
     
      try {
        const payload = {
          customer_id: this.$store.getters.customerId,
          limit: 20
        }
        const data = await fetchStaffFinanceBySearch(payload, this.query_page.current_page)

        this.payslips = data.data.data.users
        this.query_page = data.data.data.meta
        console.log(this.payslips)
      } catch (e) {
        //
      }
    }
  }
}
</script>